import React from 'react';

import Portal from 'topmeteo/general/components/Portal';

const SliderBackground = () => (
    <Portal container="map-wrapper">
        <div className="slider-background" />
    </Portal>
);

export default SliderBackground;
